import SimpleBar from 'simplebar'

document.querySelectorAll(`[data-simplebar]`).forEach((element) => {
    switch (element) {
        default:
            new SimpleBar(element)
            break
    }
})
